import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var WorkflowInstanceShortcutSvg = function WorkflowInstanceShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9013FE",
    fillRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12-1.027 0-2.025-.13-2.976-.372A9 9 0 0 0 .34 9.153C1.618 3.9 6.354 0 12 0c6.627 0 12 5.373 12 12",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.708 12q.423.472.776 1H10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h4V6h-4V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h3v5h-3v-1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1zm2.074 4.024a9 9 0 0 1 0 3.952A1 1 0 0 0 11 20h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-.218.024",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var WorkflowInstanceShortcut = function WorkflowInstanceShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: WorkflowInstanceShortcutSvg
  }));
};